export function buildForecastFilePath(
  prefix,
  siteName,
  greenhouse,
  plot,
  isoDate,
) {
  if (prefix) {
    return `${prefix}/${siteName}/${greenhouse}/${plot}/forecasts/${isoDate}/forecast.json`;
  }
  return `${siteName}/${greenhouse}/${plot}/forecasts/${isoDate}/forecast.json`;
}

export function getTotalYield(
  jsonData,
  avgYieldKeyName,
  totalRows,
  areaPerRow,
  areaOfGH,
  averageYieldPerSqMeterKeyName,
) {
  const rawValue = jsonData?.[avgYieldKeyName] ?? 0;
  if (areaPerRow && areaOfGH) {
    return Math.round((rawValue / (areaPerRow ?? 1)) * (areaOfGH ?? 0));
  }
  if (averageYieldPerSqMeterKeyName && areaOfGH) {
    const yieldPerSqMeter = jsonData?.[averageYieldPerSqMeterKeyName] ?? 0;
    return Math.round(yieldPerSqMeter * (areaOfGH ?? 0));
  }
  return Math.round(rawValue * (totalRows ?? 0));
}

export function weekToNumber(year, week) {
  return year * 52 + week;
}
export function isWeekInRange(year, week, from, to) {
  const val = weekToNumber(year, week);
  const fromVal = weekToNumber(from.YEAR, from.WEEK);
  const toVal = weekToNumber(to.YEAR, to.WEEK);
  return val >= fromVal && val <= toVal;
}

export function getSiteForecastConfig(siteObj, cropName) {
  const cropMeta = siteObj?.metadata?.[cropName] || {};
  const forecastMeta = cropMeta?.forecast || {};

  const averageYieldKeyName =
    forecastMeta.AVERAGE_YIELD_KEY || "AverageRowYield";

  const refinedAverageYieldKeyName =
    forecastMeta.REFINED_AVERAGE_YIELD_KEY || "RefinedAverageRowYield";

  let summaryAverageYieldKeyName = forecastMeta.SUMMARY_AVERAGE_YIELD_KEY;
  if (!summaryAverageYieldKeyName) {
    summaryAverageYieldKeyName = refinedAverageYieldKeyName;
  }

  return {
    prefixForecastPath: forecastMeta.PREFIX_FORECAST_PATH || "",
    totalRows: forecastMeta.TOTAL_ROWS || 0,
    areaPerRow: forecastMeta.AREA_PER_ROW || 0,
    areaOfGH: forecastMeta.AREA_OF_GH || 0,
    averageYieldKeyName,
    refinedAverageYieldKeyName,
    summaryAverageYieldKeyName,
    averageYieldPerSqMeterKeyName:
      forecastMeta.AVERAGE_YIELD_PER_SQ_METER || "AverageRowYieldPerSqMeter",
  };
}
